import { Route, Switch } from "react-router-dom";

import LoginScreen from "./Auth/loginScreen";
import { ForgetPassword } from "./Auth/ForgetPasswordScreen";
import { Dashboard } from "./Navigation/Dashboard";
// import { Occurrences } from "./Navigation/Occurrences";
import { Clients } from "./Navigation/Clients";
import { Profile } from "./Navigation/Profile";
import { Users } from "./Navigation/Users";
import { Policemen } from "./Navigation/Policemen";
import { Providers } from "./Navigation/Providers";
import { SuperficialClients } from "./Navigation/SuperficialClients";
import { PrivateRoute } from "components/Routes/PrivateRoute";
import { GuestRoute } from "components/Routes/GuestRoute";
import { NotFound } from "./Navigation/NotFound";
import { Payments } from "./Navigation/Payments";
import { Map } from "./Navigation/Map";
// import { FinancialRoute } from "components/Routes/FinancialRoute";
import { Monitoring } from "./Navigation/Monitoring";
import { ManualOccurrenceProvider } from "contexts/register/ManualOccurrence";
import { ProviderRegister } from "./Guest/ProviderRegister";
import { HistoricOccurrences } from "./Navigation/Historic";
import SharedOccurrence from "./Navigation/SharedOccurrence";

import OccurrenceMap from "./Navigation/OccurrenceMap";
import Manual from "./Navigation/Manual";
import { Maintenance } from "./Navigation/Maintenance";

function MonitoringWithContext() {
  return (
    <ManualOccurrenceProvider>
      <Monitoring />
    </ManualOccurrenceProvider>
  );
}

function OccurrencesWithContext() {
  return (
    <ManualOccurrenceProvider>
      <HistoricOccurrences />
    </ManualOccurrenceProvider>
  );
}

function OccurrenceMapWithContext() {
  return (
    <ManualOccurrenceProvider>
      <OccurrenceMap />
    </ManualOccurrenceProvider>
  );
}

export default function Routes() {
  return (
    <Switch>
      <PrivateRoute component={Clients} path="/clients" />
      <PrivateRoute component={Maintenance} path="/maintenance" />
      <PrivateRoute component={Manual} path="/manual" />

      <PrivateRoute component={SuperficialClients} path="/sub-clients" />
      <PrivateRoute component={Providers} path="/providers" />
      <PrivateRoute component={Policemen} path="/policemen" />
      <PrivateRoute component={Users} path="/users" />
      <PrivateRoute component={Profile} path="/profile" />
      <GuestRoute component={ForgetPassword} path="/forget-password" />
      <Route component={SharedOccurrence} path="/share/:shareToken" />
      <GuestRoute component={ProviderRegister} path="/provider-register" />
      <Route component={SharedOccurrence} path="/share/:occurrenceId" />
      <PrivateRoute component={Payments} path="/payments" />
      <PrivateRoute component={Dashboard} path="/home" />
      <PrivateRoute component={OccurrencesWithContext} path="/occurrences" />
      <PrivateRoute component={MonitoringWithContext} path="/monitor" />
      <PrivateRoute
        component={OccurrenceMapWithContext}
        path="/map/:occurrenceId"
      />
      <PrivateRoute component={Map} path="/map" />
      <GuestRoute exact component={LoginScreen} path="/" />
      <PrivateRoute component={NotFound} path="*" />
    </Switch>
  );
}
